import { TenantConfig } from "../tenant.model";

export const tenant: TenantConfig = {
    tenandId: 'asrem',
    brandName: 'Asrem',
    brandLogoImage: null,
    showSupplierLogo: false,
    apiUrl: 'https://api.asrem.test.assistant.beta80group.it',
    apiUrlProd: 'https://api.asrem.assistant.beta80group.it',
    navigationItems: [
        { label: 'Home', route: '/overview', group: 'settings' },
        { label: 'Statistiche', route: '/statistiche', group: 'navigation', featureName: 'statistics', requiresAdmin: true },
        { label: 'Documenti', route: '/documenti', group: 'navigation', featureName: 'document', requiresAdmin: true },
        { label: 'Conversazioni', route: '/conversazioni', group: 'navigation', featureName: 'conversations' },
        { label: 'Valutazioni', route: '/valutazioni', group: 'navigation', featureName: 'feedback' },
        { label: 'Ricerca Chunks', route: '/chunks', group: 'navigation' },
        { label: 'Permessi', route: '/permessi', group: 'navigation', featureName: 'permissions', requiresAdmin: true },
        { label: 'Impostazioni', route: '/impostazioni', group: 'navigation', featureName: 'settings', requiresAdmin: true },
    ],
    apiEndpoints: {
        document: '/document',
        assistant: '/assistant',
    },
    documentiApi: '/document',
    samlProviderName: 'assistant-external-idp',
    samlEnabled: false,
    chatConfig: {
        // TRUE = Scarica da CloudFront oppure FALSE = Usa il file asrem-chat.bundle.js presente nella cartella del componente
        useRemoteLoader: true,
        remoteTestUrl: 'https://d3so8u9uewocbp.cloudfront.net/bundle/asrem-chat.bundle.js',
        remoteProdUrl: 'https://d11zdqjy12f21w.cloudfront.net/bundle/asrem-chat.bundle.js',
        bundleFile: 'asrem-chat.bundle.js',
        elementTag: 'asrem-chat',
        assistantName: 'MIA',
        envConfig: {
            uat: { apiEndpoint: 'https://api.asrem.test.assistant.beta80group.it' },
            prod: { apiEndpoint: 'https://api.asrem.assistant.beta80group.it' },
        },
        assistantImage: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAADnElEQVR4nO2ZS2wTVxSGv3Eek4ckJCG8kgBtQ1tKH6LQ8q6oi1ZdVBW7sqhYVF2xYVVVXSAhCbEA1E1XSKzYsKhYtIuqiyIoqaAtUCABmgQCAUJCQhJCHo7tOT2jjJ2xPY5nPHYW80sjRTPnnnP+c+fec+89FjD/AhqBE8AvwDgwA3xg/qcB+Az4FmgBLBZBK/ATsABY+bxmgdDcAhwClsyGy5gKzmkGWoF/tFdR/AucB9qwANqAG1rRbPgQ+FEjvY3t7hLwJVsPr2Ft4KoW/xzwFdvAV8BfWgtfA7tYB3YDV7RLnwPexjrxNvCnVvQr4G02iTeAmxrxb9gkqoB72qLHA1SzSVQDdzUB04B3M3ihHBjQBGmXNgONWjxMAfU56FEN9GoXn2ST+AewVROgyZdGNVvP99q9r7AO7AdGNCK3WSeCOJ17WEcqgSFNiGtsI9dxVvIMmxRhfQGMaaS/YRs5i7OjjrAJVOFsvj0Yg2pglC3gfZwXYIgsqQIubUbAPE4HTaEZKAPOa8LPYSwqgTObJaCGzeUE6SldBdSySfyB8+oYgwrgZDqF12A8zuC8RsagHMd4x+F1jMc5nJnFGFTiGH83RqQW+E8T5MdIamqBYzjT5TiOKYcxJnWa8KGXZsH4tYnznzLg09fA/5ryk8BBNpf9OL3vuib8lJZQYxxaMB4tQLdG+AKb2w23AJe18LOYh06cXh/HsD4WnBlmCqfbNhnd2oWnsQ50a3rMAXUYi1rgT+3Su/h0nVwGDGFMhoAy/Lgbp1PMYVw6caZTa5vXiN3a5gxG5rp26W0k1+Ma2S7M4Qucbu9zJFeWu0g+2DzBaziGvAQUMUvyB1Yxm8h5kgdfPRiTx8BJkp+KHMeYjAAfAe/ivECXYGx2Ax8AY8BhfN6a/4OvgQ5SlFsyG04nrhaUqrGdXgUOYizKgA+BO/hQjkSLtgD9bFyKNO0k3/k2k/4KbBT1OF1jG2sBXyfNs6RP0Q3UYBwO4EzZy3Q0AIcxFnu1y06SSWk29WINcERKY3Zxty2UWG++xVkcrwDv4DzfSzAmo8BGXTRpAoZpJfOOvdF1vQTnc8w4jskaILOdV4ryI06XWKZO9TvAvtR1bkgx78+IskOl9J/yJ7Qrf6uVPOvLM6CfdMUVJb8JpwR4gDTFdvBPNKKrgN/Z/BLOJ5r4u0j+Bac8Skf1c3k+NawF6NDiX8RZr34xUoEVLe454EvUuzBf4fgfFLXaEhD8y28AAAAASUVORK5CYII='
    },
    amplifyConfig: {
        // samlAuth: {
        //     region: 'eu-central-1',
        //     userPoolId: 'eu-central-1_qlOdffouZ',
        //     userPoolWebClientId: '25jfn5r7rq5u5937h66e7b10g3',
        //     mandatorySignIn: false,
        //     authenticationFlowType: 'USER_SRP_AUTH',
        //     customCinecaLogoutUrl: 'https://lumsa.idp.pp.cineca.it/idp/profile/Logout',
        //     oauth: {
        //         domain: 'eu-central-1qlodffouz.auth.eu-central-1.amazoncognito.com',
        //         scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'profile'],
        //         redirectSignIn: 'http://localhost:4200/',
        //         redirectSignOut: 'http://localhost:4200/logout-handler',
        //         responseType: 'code',
        //     },
        // },
        // Configurazione per l'autenticazione nativa
        nativeAuth: {
            region: 'eu-central-1',
            userPoolId: 'eu-central-1_4jYTakQaH',
            userPoolWebClientId: '2p1bdkkk8f30123uccqaf04s1',
            mandatorySignIn: false,
            authenticationFlowType: 'USER_PASSWORD_AUTH',
            oauth: {
                domain: 'eu-central-1qlodffouz.auth.eu-central-1.amazoncognito.com',
                scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'profile'],
                redirectSignIn: 'http://localhost:4200/',
                redirectSignOut: 'http://localhost:4200/',
                responseType: 'code',
            },
        },
        nativeAuthProd: {
            region: 'eu-central-1',
            userPoolId: 'eu-central-1_MPOibWzsD',
            userPoolWebClientId: '5a0ek36m89je9q55racv22b54c',
            mandatorySignIn: false,
            authenticationFlowType: 'USER_PASSWORD_AUTH',
            oauth: {
                domain: 'eu-central-1mpoibwzsd.auth.eu-central-1.amazoncognito.com',
                scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'profile'],
                redirectSignIn: 'https://asrem.assistant.beta80group.it/',
                redirectSignOut: 'https://asrem.assistant.beta80group.it/',
                responseType: 'code',
            },
        },
    },
    theme: {
        semantic: {
            primary: {
                50: '#e6f0f3',
                100: '#b3d1d9',
                200: '#80b2bf',
                300: '#4d93a5',
                400: '#1a748b',
                500: '#003B55',
                600: '#002f44',
                700: '#002333',
                800: '#001722',
                900: '#000b11',
                950: '#000508',
            },
            danger: {
                50: '#fef2f2',
                100: '#fee2e2',
                200: '#fecaca',
                300: '#fca5a5',
                400: '#f87171',
                500: '#74262B',
                600: '#5e1e22',
                700: '#4a181c',
                800: '#371215',
                900: '#240c0e',
                950: '#180809',
            },
            secondary: {
                50: '#f5f5f5',
                100: '#e5e5e5',
                200: '#cccccc',
                300: '#b3b3b3',
                400: '#999999',
                500: '#555555',
                600: '#444444',
                700: '#333333',
                800: '#222222',
                900: '#111111',
                950: '#0a0a0a',
            },
            formField: {
                borderRadius: '4px',
                paddingX: '12px',
                paddingY: '12px',
                borderWidth: '2px',
            },
        },
        form: {
            iconColor: '#003B55',
        },
        components: {
            datatable: {
                headerCell: {
                    background: '#e6f0f3'
                }
            },
            card: {
                body: {
                    padding: '0',
                }
            },
            dialog: {
                header: {
                    padding: '32px 32px 0 32px',
                },
                content: {
                    padding: '32px',
                },
                footer: {
                    padding: '0 32px 32px 32px',
                }
            },
        }
    },
};
